import { render, staticRenderFns } from "./ImgPreviews.vue?vue&type=template&id=b4ada030&scoped=true&"
import script from "./ImgPreviews.vue?vue&type=script&lang=js&"
export * from "./ImgPreviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ada030",
  null
  
)

export default component.exports